module.exports = __webpack_public_path__ + "static/media/02_placement-ID.e23c9730.gif";